// extracted by mini-css-extract-plugin
module.exports =  {"input-param":"input-param--BsVDs","inputParam":"input-param--BsVDs"};